webpackJsonp([100691214015113],{

/***/ 373:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Apply":"src-components-Apply-Interest----Apply-module---Apply---dXkTH","Button":"src-components-Apply-Interest----Apply-module---Button---1LoWR"};

/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ApplyModule = __webpack_require__(373);
	
	var _ApplyModule2 = _interopRequireDefault(_ApplyModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ApplyInterest = function ApplyInterest(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _ApplyModule2.default.Apply },
	    _react2.default.createElement(
	      'h2',
	      { className: 'h2' },
	      props.title
	    ),
	    props.buttonTitle ? _react2.default.createElement(
	      'a',
	      { className: _ApplyModule2.default.Button, href: props.buttonUrl, target: '_blank' },
	      props.buttonTitle
	    ) : _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/interest-form/', className: _ApplyModule2.default.Button },
	      'Learn More'
	    )
	  );
	};
	
	exports.default = ApplyInterest;
	module.exports = exports['default'];

/***/ }),

/***/ 376:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Destinations":"src-components-Program-Destinations----Destinations-module---Destinations---1idFy","Cards":"src-components-Program-Destinations----Destinations-module---Cards---2GXFp","Card":"src-components-Program-Destinations----Destinations-module---Card---1R22p"};

/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(22);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _DestinationsModule = __webpack_require__(376);
	
	var _DestinationsModule2 = _interopRequireDefault(_DestinationsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Destinations = function Destinations(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _DestinationsModule2.default.Destinations, id: 'destinations' },
	    _react2.default.createElement(
	      'h2',
	      { className: 'h2' },
	      props.title
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'p-large' },
	      props.text
	    ),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: props.link.link, className: 'button' },
	      props.link.text
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _DestinationsModule2.default.Cards },
	      props.cards.map(function (card, i) {
	        return _react2.default.createElement(
	          'div',
	          { className: _DestinationsModule2.default.Card, key: i },
	          _react2.default.createElement(_gatsbyImage2.default, { sizes: card.featuredImage.sizes, alt: card.featuredImage.title }),
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: 'hoverlink', to: card.link.link },
	            card.link.text
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = Destinations;
	module.exports = exports['default'];

/***/ }),

/***/ 731:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Download":"src-components-Program-Download----Download-module---Download---2ZZTr","Download__Wrapper":"src-components-Program-Download----Download-module---Download__Wrapper---2Eicx","Download__Button":"src-components-Program-Download----Download-module---Download__Button---2ilV9","Download__Form":"src-components-Program-Download----Download-module---Download__Form---3BtWE","Download__Form__Expanded":"src-components-Program-Download----Download-module---Download__Form__Expanded---x5A75","FormElement":"src-components-Program-Download----Download-module---FormElement---1J4MN","FormElementActive":"src-components-Program-Download----Download-module---FormElementActive---3x-2x"};

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _axios = __webpack_require__(46);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _DownloadModule = __webpack_require__(731);
	
	var _DownloadModule2 = _interopRequireDefault(_DownloadModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Download = function (_React$Component) {
	    _inherits(Download, _React$Component);
	
	    function Download(props) {
	        _classCallCheck(this, Download);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.valueUpdater = function (field) {
	            return function (event) {
	                var _extends2;
	
	                var value = event.target.value;
	
	                var newState = _extends({}, _this.state, (_extends2 = {}, _extends2[field] = value, _extends2));
	                _this.setState(newState);
	            };
	        };
	
	        _this.state = {
	            email: '',
	            expanded: false,
	            error: false,
	            submit: false
	        };
	        _this.valueUpdater = _this.valueUpdater.bind(_this);
	        _this.expandSubmit = _this.expandSubmit.bind(_this);
	        return _this;
	    }
	
	    Download.prototype.validateEmail = function validateEmail(email) {
	        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	        return re.test(String(email).toLowerCase());
	    };
	
	    Download.prototype.expandSubmit = function expandSubmit() {
	        var _this2 = this;
	
	        var email = this.refs.email;
	
	
	        if (this.state.expanded === false) {
	            this.setState({ expanded: true });
	        } else {
	            var emailCheck = this.validateEmail(email.value);
	
	            if (emailCheck) {
	                var zapUrl = 'https://hooks.zapier.com/hooks/catch/1060428/qamqep/';
	                var payload = {
	                    "email": email.value
	                };
	                _axios2.default.post(zapUrl, JSON.stringify(payload)).then(function (res) {
	                    if (res.status == 200) {
	                        _this2.setState({ submit: true });
	                        _this2.SaveToDisk(_this2.props.file.file.url, _this2.props.file.fileName);
	                    } else {
	                        _this2.setState({ error: true });
	                    }
	                });
	            }
	        }
	    };
	
	    Download.prototype.handleSubmit = function handleSubmit(e) {
	        e.preventDefault();
	        this.expandSubmit();
	    };
	
	    Download.prototype.SaveToDisk = function SaveToDisk(fileURL, fileName) {
	        // for non-IE
	        if (!window.ActiveXObject) {
	            var save = document.createElement('a');
	            save.href = fileURL;
	            save.target = '_blank';
	            save.download = fileName || 'unknown';
	
	            var evt = new MouseEvent('click', {
	                'view': window,
	                'bubbles': true,
	                'cancelable': false
	            });
	            save.dispatchEvent(evt);
	
	            (window.URL || window.webkitURL).revokeObjectURL(save.href);
	        }
	
	        // for IE < 11
	        else if (!!window.ActiveXObject && document.execCommand) {
	                var _window = window.open(fileURL, '_blank');
	                _window.document.close();
	                _window.document.execCommand('SaveAs', true, fileName || fileURL);
	                _window.close();
	            }
	    };
	
	    Download.prototype.render = function render() {
	        var _this3 = this;
	
	        return _react2.default.createElement(
	            'div',
	            { className: _DownloadModule2.default.Download },
	            _react2.default.createElement(
	                'div',
	                { className: _DownloadModule2.default.Download__Wrapper },
	                _react2.default.createElement(
	                    'h2',
	                    null,
	                    'Download the Program Details.'
	                ),
	                _react2.default.createElement(
	                    'form',
	                    { className: _DownloadModule2.default.Download__Form + ' ' + (this.state.expanded && _DownloadModule2.default.Download__Form__Expanded), onSubmit: function onSubmit(e) {
	                            return _this3.handleSubmit(e);
	                        } },
	                    _react2.default.createElement(
	                        'div',
	                        { className: _DownloadModule2.default.FormElement + ' ' + (this.state.email !== '' ? _DownloadModule2.default.FormElementActive : '') },
	                        _react2.default.createElement('input', { type: 'email', id: 'email-input', name: 'email', value: this.state.email, onChange: this.valueUpdater('email'), ref: 'email' }),
	                        _react2.default.createElement(
	                            'label',
	                            { htmlFor: 'email-input' },
	                            'Email Address'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'a',
	                    { className: _DownloadModule2.default.Download__Button, onClick: function onClick() {
	                            return _this3.expandSubmit();
	                        } },
	                    _react2.default.createElement('img', { src: '/images/icon-downarrow-orange.svg', alt: 'down arrow' }),
	                    ' Download PDF'
	                ),
	                this.state.error && !this.state.submit && _react2.default.createElement(
	                    'p',
	                    null,
	                    'Something appears to have gone wrong, please contact us directly!'
	                )
	            )
	        );
	    };
	
	    return Download;
	}(_react2.default.Component);
	
	exports.default = Download;
	module.exports = exports['default'];

/***/ }),

/***/ 732:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Experience":"src-components-Program-Experience----Experience-module---Experience---JDeyW","Step":"src-components-Program-Experience----Experience-module---Step---23NKo","Step__date":"src-components-Program-Experience----Experience-module---Step__date---1Aiyb"};

/***/ }),

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ExperienceModule = __webpack_require__(732);
	
	var _ExperienceModule2 = _interopRequireDefault(_ExperienceModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Experience = function Experience(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _ExperienceModule2.default.Experience, id: 'experience' },
	    _react2.default.createElement(
	      'h2',
	      { className: 'h2' },
	      props.title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _ExperienceModule2.default.Experience__steps },
	      props.steps.map(function (step, i) {
	        return _react2.default.createElement(
	          'div',
	          { className: _ExperienceModule2.default.Step, key: i },
	          i === 0 && _react2.default.createElement('img', { src: '/images/experience-one.svg', alt: 'experience steps' }),
	          i === 1 && _react2.default.createElement('img', { src: '/images/experience-two.svg', alt: 'experience steps' }),
	          i === 2 && _react2.default.createElement('img', { src: '/images/experience-three.svg', alt: 'experience steps' }),
	          _react2.default.createElement(
	            'p',
	            { className: _ExperienceModule2.default.Step__date },
	            step.timeframe
	          ),
	          _react2.default.createElement(
	            'h3',
	            { className: 'h3' },
	            step.title
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'p-large' },
	            step.details.details
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = Experience;
	module.exports = exports['default'];

/***/ }),

/***/ 733:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"FAQ":"src-components-Program-FAQ----FAQ-module---FAQ---20hQB","FAQ__Item":"src-components-Program-FAQ----FAQ-module---FAQ__Item---dybY7"};

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _FAQModule = __webpack_require__(733);
	
	var _FAQModule2 = _interopRequireDefault(_FAQModule);
	
	var _marked = __webpack_require__(11);
	
	var _marked2 = _interopRequireDefault(_marked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FAQ = function FAQ(props) {
		return _react2.default.createElement(
			'div',
			{ className: _FAQModule2.default.FAQ, id: 'faq' },
			_react2.default.createElement(
				'h2',
				{ className: 'h2' },
				props.title
			),
			props.items.map(function (item, i) {
				return _react2.default.createElement(
					'div',
					{ className: _FAQModule2.default.FAQ__Item, key: i },
					_react2.default.createElement(
						'p',
						null,
						item.question
					),
					_react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: (0, _marked2.default)(item.answer.answer) } })
				);
			}),
			_react2.default.createElement(
				_gatsbyLink2.default,
				{ to: props.link.link, className: 'hoverlink' },
				props.link.text
			)
		);
	};
	
	exports.default = FAQ;
	module.exports = exports['default'];

/***/ }),

/***/ 735:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Navigation":"src-components-Program-Navigation----Navigation-module---Navigation---3s-_P","Navigation__wrapper":"src-components-Program-Navigation----Navigation-module---Navigation__wrapper---i02lc"};

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _NavigationModule = __webpack_require__(735);
	
	var _NavigationModule2 = _interopRequireDefault(_NavigationModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Navigation = function Navigation(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: _NavigationModule2.default.Navigation, ref: props.callbackRef },
	    _react2.default.createElement(
	      'div',
	      { className: _NavigationModule2.default.Navigation__wrapper },
	      _react2.default.createElement(
	        'a',
	        { href: '#experience', className: props.activeNav === 'experience' ? 'active-nav' : '' },
	        'The Experience'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#destinations', className: props.activeNav === 'destinations' ? 'active-nav' : '' },
	        'The Destinations'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: '#faq', className: props.activeNav === 'faq' ? 'active-nav' : '' },
	        'FAQ'
	      )
	    )
	  );
	};
	
	exports.default = Navigation;
	module.exports = exports['default'];

/***/ }),

/***/ 601:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(6);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _CustomHelmet = __webpack_require__(7);
	
	var _CustomHelmet2 = _interopRequireDefault(_CustomHelmet);
	
	var _ApplyInterest = __webpack_require__(333);
	
	var _ApplyInterest2 = _interopRequireDefault(_ApplyInterest);
	
	var _Afterhero = __webpack_require__(292);
	
	var _Afterhero2 = _interopRequireDefault(_Afterhero);
	
	var _Destinations = __webpack_require__(340);
	
	var _Destinations2 = _interopRequireDefault(_Destinations);
	
	var _Download = __webpack_require__(539);
	
	var _Download2 = _interopRequireDefault(_Download);
	
	var _Experience = __webpack_require__(540);
	
	var _Experience2 = _interopRequireDefault(_Experience);
	
	var _FAQ = __webpack_require__(541);
	
	var _FAQ2 = _interopRequireDefault(_FAQ);
	
	var _Hero = __webpack_require__(293);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Navigation = __webpack_require__(542);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollMagic;
	if (typeof window === 'object') {
	    ScrollMagic = __webpack_require__(24);
	}
	
	// if(typeof window == 'object') {
	// 	require('imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js')
	// }
	
	var ProgramOverview = function (_React$Component) {
	    _inherits(ProgramOverview, _React$Component);
	
	    function ProgramOverview(props) {
	        _classCallCheck(this, ProgramOverview);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = {
	            activeNav: '',
	            controller: null
	        };
	        return _this;
	    }
	
	    ProgramOverview.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        // console.log('TAKE 2 ==>', this.pageNav);
	        var experience = document.querySelector('#experience'),
	            destinations = document.querySelector('#destinations'),
	            faq = document.querySelector('#faq'),
	            offset = 420;
	
	        this.controller = new ScrollMagic.Controller();
	        this.setState({
	            controller: this.controller
	        });
	        setTimeout(function () {
	            return _this2.navSceneInit();
	        }, 450);
	
	        window.addEventListener('scroll', function () {
	            var experienceTrigger = experience.offsetTop - offset,
	                destinationsTrigger = destinations.offsetTop - offset,
	                faqTrigger = faq.offsetTop - offset;
	
	            var doc = document.documentElement,
	                top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
	
	            if (top > faqTrigger) {
	                _this2.state.activeNav != 'faq' ? _this2.setState({ activeNav: 'faq' }) : null;
	            } else if (top > destinationsTrigger) {
	                _this2.state.activeNav != 'destinations' ? _this2.setState({ activeNav: 'destinations' }) : null;
	            } else if (top > experienceTrigger) {
	                _this2.state.activeNav != 'experience' ? _this2.setState({ activeNav: 'experience' }) : null;
	            } else {
	                _this2.state.activeNav != '' ? _this2.setState({ activeNav: '' }) : null;
	            }
	        });
	    };
	
	    ProgramOverview.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.state.controller.destroy(true);
	        this.controller.destroy(true);
	    };
	
	    ProgramOverview.prototype.navSceneInit = function navSceneInit() {
	        var triggerHook = window.innerWidth > 768 ? .3 - 207 / window.innerHeight : 45 / window.innerHeight;
	
	        this.navScene = new ScrollMagic.Scene({
	            triggerElement: this.pageNav,
	            triggerHook: triggerHook
	        }).setPin(this.pageNav.children[0]).addTo(this.controller);
	        // .addIndicators()
	    };
	
	    ProgramOverview.prototype.render = function render() {
	        var _this3 = this;
	
	        var page = this.props.data.page;
	
	        var seoKeywords = page.seoData.keywords ? page.seoData.keywords.toString() : '';
	        // console.log('THE PAGE DATA ===>', page);
	        return _react2.default.createElement(
	            'div',
	            { className: 'program' },
	            _react2.default.createElement(_CustomHelmet2.default, { data: page.seoData }),
	            _react2.default.createElement(_Hero2.default, {
	                title: page.title,
	                image: page.heroImage
	            }),
	            _react2.default.createElement(_Navigation2.default, {
	                activeNav: this.state.activeNav,
	                callbackRef: function callbackRef(el) {
	                    return _this3.pageNav = el;
	                }
	            }),
	            _react2.default.createElement(_Afterhero2.default, {
	                text: page.heroSplashText.heroSplashText
	            }),
	            _react2.default.createElement(_Experience2.default, {
	                title: page.experienceTitle,
	                steps: page.experienceSteps
	            }),
	            _react2.default.createElement(_Download2.default, {
	                file: page.pdfDownload
	            }),
	            _react2.default.createElement(_Destinations2.default, {
	                title: page.destinationsTitle,
	                text: page.destinationsText,
	                link: page.destinationsLink,
	                cards: page.destinationItems
	            }),
	            _react2.default.createElement(_FAQ2.default, {
	                title: page.faqTitle,
	                items: page.faqItems,
	                link: page.faqLink
	            }),
	            _react2.default.createElement(_ApplyInterest2.default, {
	                title: page.applyTitle
	            })
	        );
	    };
	
	    return ProgramOverview;
	}(_react2.default.Component);
	
	exports.default = ProgramOverview;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-program-overview-js-7ad9ca7f9ff3f0618a67.js